import { DownloadAuthoringPdfMenuItem } from "authoring/routes/pdf/download-authoring-pdf-menu-item"

export function DownloadDifferencesPdf() {
    return (
        <DownloadAuthoringPdfMenuItem
            mode="differences"
            label="Download internal PDF: differences (includes internal notes)"
            dataCy="download-differences-pdf-menu-item"
        />
    )
}
